/**
 * @param configurations
 * @param requestedProjectId
 * @param requestedIssuetype
 */
export function getApplicableConfiguration(configurations, requestedProjectId, requestedIssuetype) {
    const index = indexOfApplicableConfig(configurations, requestedProjectId, requestedIssuetype);
    return configurations[index];
}
export function indexOfApplicableConfig(configurations, requestedProjectId, requestedIssuetypeId) {
    return configurations.findIndex(({ projectId, issuetypeId, enabled }) => projectId === requestedProjectId && issuetypeId === requestedIssuetypeId && enabled);
}
